import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import Skeleton from './system/Skeleton';

// Layout route: renders the shared SiteHeader once, with the matched child
// route rendered via <Outlet/>. Per-page breadcrumb context flows through
// BreadcrumbContext (see lib/BreadcrumbContext.js) rather than props, so no
// route needs to pass anything different into SiteHeader here.
//
// Route-level components (Event/RapSheet/Aircraft/Region/About/Styleguide)
// are React.lazy in App.js, so a single Suspense boundary here covers all
// of them with one generic fallback while their chunks stream in.
function SiteLayout() {
  return (
    <>
      <SiteHeader />
      <Suspense fallback={<Skeleton blocks={['chip', 'stats', 'block']} label="loading page" />}>
        <Outlet />
      </Suspense>
    </>
  );
}

export default SiteLayout;
